//----- Component --------------------------------------------------------/
// Developer     : Guillermo Sedran
// Creation Date : 04/02/2025
// Version       : 1
// Description   : Gráfico que muestra las observaciones mensuales del vehículo
//
//------Changes ----------------------------------------------------------------------------------//
// Change Date   :
// Change by     :
// Change description:
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/

import { useState, useEffect } from "react";
import { UrlApi } from "../../../services/apirest";
import { MenuItem, Select, InputLabel, FormControl } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";

function ChartObservaciones({ vehiculo }) {
  const chartWidth = window.innerWidth; // Obtiene el ancho de la pantalla

  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);

  // ------------------------------------

  const [observacionesxanio, setObservacionesxanio] = useState([]);

  const obtenerObservaciones = (year) => {
    fetch(
      `${UrlApi}/vehiculos_revision/observacionesxanio/vehiculo/${vehiculo.id_vehiculo}/anio/${year}`
    )
      .then((data) => data.json())
      .then((data) => {
        setObservacionesxanio(data);
      })
      .catch((error) =>
        console.error("Error al obtener observaciones:", error)
      );
  };

  useEffect(() => {
    obtenerObservaciones(selectedYear);
  }, [selectedYear]);

  // ------------------------------------

  // Detectar el tamaño de la pantalla para ajustar el chart
  const [chartSize, setChartSize] = useState({
    width:
      window.innerWidth < 600 ? window.innerWidth - 20 : window.innerWidth - 80, // Menos margen
    height: window.innerWidth < 600 ? 280 : 370, // Reducir altura en móvil
  });

  useEffect(() => {
    const handleResize = () => {
      setChartSize({
        width:
          window.innerWidth < 600
            ? window.innerWidth - 20
            : window.innerWidth - 80,
        height: window.innerWidth < 600 ? 280 : 370,
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ------------------------------------

  // Array con los nombres de los 12 meses
  const mesesDelAnio = [
    "Ene",
    "Feb",
    "Mar",
    "Abr",
    "May",
    "Jun",
    "Jul",
    "Ago",
    "Sep",
    "Oct",
    "Nov",
    "Dic",
  ];

  // Crear un array con 12 posiciones en 0 (por si algún mes no tiene datos)
  const datosObservaciones = new Array(12).fill(0);

  // Valores obtenidos asignados al mes correspondiente
  observacionesxanio.forEach(({ mes, cantidad_observaciones }) => {
    const index = parseInt(mes.split("-")[1], 10) - 1; // Extraer el número del mes y convertirlo a índice (0-11)
    datosObservaciones[index] = cantidad_observaciones; // Valor
  });

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: window.innerWidth < 600 ? "-10px" : "10px", // Ajusta en mobile
          position: "relative", // Necesario para la superposición
        }}
      >
        {/* Selector de Año */}
        <FormControl
          sx={{
            minWidth: "100px", // Tamaño en escritorio
            "@media (max-width: 600px)": {
              minWidth: "70px", // Tamaño más pequeño en móviles
            },
          }}
          size="small"
        >
          <InputLabel
            id="demo-simple-select-label"
            sx={{
              fontSize: "1rem", // Tamaño en escritorio
              top: "2px",
              "@media (max-width: 600px)": {
                fontSize: "0.8rem", // Tamaño más pequeño en móviles
              },
            }}
          >
            Año
          </InputLabel>
          <Select
            label="Año"
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
            size="small"
            sx={{
              minWidth: "100px", // Tamaño en escritorio
              height: "40px",
              fontSize: "1rem",
              padding: "6px 10px",
              "@media (max-width: 600px)": {
                minWidth: "70px", // Tamaño más pequeño en móviles
                height: "30px",
                fontSize: "0.8rem",
                padding: "4px 8px",
              },
            }}
          >
            {[currentYear - 2, currentYear - 1, currentYear].map((year) => (
              <MenuItem
                key={year}
                value={year}
                sx={{
                  fontSize: "0.9rem", // Tamaño en escritorio
                  padding: "6px 10px",
                  "@media (max-width: 600px)": {
                    fontSize: "0.7rem", // Tamaño más pequeño en móviles
                    padding: "4px 8px",
                  },
                }}
              >
                {year}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      {/* Contenedor del gráfico con ajuste dinámico */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          height: "80%",
          maxHeight: window.innerWidth < 600 ? "60vh" : "auto",
          marginTop: "16px", // Agrega un margen superior para separar del selector
        }}
      >
        <BarChart
          xAxis={[
            {
              scaleType: "band",
              data: mesesDelAnio,
            },
          ]}
          yAxis={[{ tickMinStep: 1 }]}
          series={[
            {
              data: datosObservaciones,
              label: "Observaciones",
              color: "#4CAF50",
            },
          ]}
          width={chartWidth}
          height={chartSize.height}
          barLabel="value"
        />
      </div>
    </>
  );
}

export default ChartObservaciones;
